import type { AxiosInstance } from "axios";

export class HttpClient {
  headers: Record<string, any>;
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json",
    };
    this.client = client;
  }

  get<T = any>({ url, headers, params }: HttpMethodParamsProps) {
    const requestHeaders = this.prepareHeaders(headers);
    return this.client.get<T>(url, { headers: requestHeaders, params });
  }

  post<T = any>({ url, headers, data }: HttpMethodParamsProps) {
    const requestHeaders = this.prepareHeaders(headers, data);
    return this.client.post<T>(url, data, { headers: requestHeaders });
  }

  put<T = any>({ url, headers, data }: HttpMethodParamsProps) {
    const requestHeaders = this.prepareHeaders(headers, data);
    return this.client.put<T>(url, data, { headers: requestHeaders });
  }

  patch<T = any>({ url, headers, data }: HttpMethodParamsProps) {
    const requestHeaders = this.prepareHeaders(headers, data);
    return this.client.patch<T>(url, data, { headers: requestHeaders });
  }

  delete<T = any>({ url, headers }: HttpMethodParamsProps) {
    const requestHeaders = this.prepareHeaders(headers);
    return this.client.delete<T>(url, { headers: requestHeaders });
  }

  private prepareHeaders(headers: any, data?: unknown) {
    const merged: Record<string, any> = {
      ...this.headers,
      ...headers,
    };

    // When payload is FormData, let axios/browser set the correct
    // `multipart/form-data; boundary=...` Content-Type header.
    if (typeof FormData !== "undefined" && data instanceof FormData) {
      for (const k of Object.keys(merged)) {
        if (k.toLowerCase() === "content-type") delete merged[k];
      }
    }

    return merged;
  }
}

interface HttpMethodParamsProps {
  url: string;
  headers?: Record<string, any>;
  data?: Record<string, any> | FormData;
  params?: Record<string, any>;
}
